module.exports = __webpack_public_path__ + "media/packs/images/upload-0a05ee89ba68d0dfce9111b5977571de.svg";